import {
  GET_DOMAINS,
  GET_ROOMS,
  GET_ADVICES,
  SET_DOMAINS,
  SET_ROOMS,
  SET_ADVICES,
  GET_DOMAINS_ERROR,
  GET_ROOMS_ERROR,
  GET_ADVICES_ERROR,
  SET_ADVICE_ID,
  SET_ADVICE_FILTERS,
  RESET_ADVICE_FILTERS,
  SET_DOMAIN_ROOMS_SELECTION
} from './types'
import axios from 'axios'
import Config from 'config'
import store from 'store'
import {
  removeByIdFromArray,
  setNullAttrByKeyAndValue,
  replaceByTargetFromArray,
  handleTZOffset
} from 'helpers/dataHelpers'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { createLatestRequest } from 'helpers/latestRequest'


const { apiUrl } = Config.network

export function setActiveAdviceId(id) {
  return function action(dispatch) {
    dispatch({
      type: SET_ADVICE_ID,
      payload: {
        adviceId: id
      }
    })
  }
}


export function getDomains() {
  return function action(dispatch) {
    dispatch({
      type: GET_DOMAINS
    })
    const url = `${apiUrl}domains/`
    const params = {}
    axios.get(url, { params }).then((body) => {
      const { data } = body
      dispatch({
        type: SET_DOMAINS,
        payload: {
          domains: data
        }
      })
    }).catch(error => {
      dispatch({
        type: GET_DOMAINS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function getRooms(domainId) {
  return function action(dispatch) {
    dispatch({
      type: GET_ROOMS
    })
    const url = `${apiUrl}domains/${domainId}/`
    const params = {}
    axios.get(url, { params }).then((body) => {
      const { data } = body
      dispatch({
        type: SET_ROOMS,
        payload: {
          rooms: data.rooms
        }
      })
    }).catch(error => {
      dispatch({
        type: GET_ROOMS_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}


const startAdvicesRequest = createLatestRequest()

export function getAdvices(next, domain, room, countries, status, group, favorites, sorting, search, assignee, dateRange) {
  return function action(dispatch) {
    const { cancelToken, isStale } = startAdvicesRequest()
    dispatch({
      type: GET_ADVICES
    })
    const url = next || `${apiUrl}advices/`
    const params = {}
    if (domain) {
      params['domain'] = domain
    }
    if (room && room.length > 0) {
      params['room'] = room.join()
    }
    if (countries && countries.length > 0) {
      params['countries'] = countries.join()
    }
    if (status) {
      params['status'] = status
    }
    if (group) {
      params['group'] = group
    }
    if (favorites) {
      params['favorites'] = favorites
    }
    if (sorting) {
      params['sorting'] = sorting
    }
    if (search) {
      params['search'] = search
    }
    if (assignee) {
      params['assignee'] = assignee
    }
    if (dateRange && dateRange['startDate']) {
      params['startDate'] = handleTZOffset(dateRange['startDate'])
    }
    if (dateRange && dateRange['endDate']) {
      params['endDate'] = handleTZOffset(dateRange['endDate'])
    }
    axios.get(url, { params, cancelToken }).then((body) => {
      if (isStale()) {
        return
      }
      const { data } = body
      if (next) {
        const { advices } = store.getState().advices
        dispatch({
          type: SET_ADVICES,
          payload: {
            advices: [...advices, ...data.results],
            advicesNext: data.next
          }
        })
      } else {
        dispatch({
          type: SET_ADVICES,
          payload: {
            advices: data.results,
            advicesNext: data.next
          }
        })
      }
    }).catch(error => {
      if (axios.isCancel(error) || isStale()) {
        return
      }
      dispatch({
        type: GET_ADVICES_ERROR
      })
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}

export function removeAdviceById(id) {
  return function action(dispatch) {
    const { advicesNext, advices } = store.getState().advices
    let currentAdvicesList = removeByIdFromArray(advices, id)
    currentAdvicesList = setNullAttrByKeyAndValue(currentAdvicesList, 'child', id)
    dispatch({
      type: SET_ADVICES,
      payload: {
        advices: currentAdvicesList,
        advicesNext: advicesNext
      }
    })
  }
}

export function updateAdviceByTarget(target) {
  return function action(dispatch) {
    const { advicesNext, advices } = store.getState().advices
    let currentAdvicesList = replaceByTargetFromArray(advices, target)
    dispatch({
      type: SET_ADVICES,
      payload: {
        advices: currentAdvicesList,
        advicesNext: advicesNext
      }
    })
  }
}

export function setAdviceFilters(filters) {
  return {
    type: SET_ADVICE_FILTERS,
    payload: {
      filters
    }
  }
}

export function resetAdviceFilters() {
  return {
    type: RESET_ADVICE_FILTERS
  }
}

export function setDomainRoomsSelection(page, domain, rooms) {
  return {
    type: SET_DOMAIN_ROOMS_SELECTION,
    payload: {
      page,
      domain,
      rooms
    }
  }
}
